import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell } from '@material-ui/core';
import classNames from 'classnames';
import _ from 'lodash';

import { RaceCompetitor } from 'src/interfaces/RacingState';
import RacingDetailContext from '../../../Context/RacingDetail.context';
import shirt from 'src/assets/images/shirt.png';
import Icon from '../../../../Icon/Icon';
import useIsMobile from 'src/hooks/useIsMobile';

interface SingleBetHorseCellProps {
  onClick: (e) => void, // eslint-disable-line no-unused-vars
  competitor: RaceCompetitor,
  formatName?: (name: string) => string, // eslint-disable-line no-unused-vars
  horseResults?: string,
  showInfo?: boolean,
  expanded?: boolean,
  showShirt?: boolean,
  checkCompetitor?: boolean,
  official?: boolean,
  position?: number,
  podiumNr?: number,
  racingType?: string,
  ellipsed: boolean
}

export default function SingleBetHorseCell({
  onClick,
  competitor,
  formatName,
  horseResults = '',
  showInfo = true,
  expanded = false,
  showShirt = false,
  checkCompetitor,
  official,
  position,
  podiumNr,
  racingType,
  ellipsed
}: SingleBetHorseCellProps) {
  const mobile = useIsMobile();
  const { hideDetail } = useContext(RacingDetailContext);
  const { t } = useTranslation('common');

  const horseName = competitor.horse && competitor.horse.name ? competitor.horse.name : competitor.name;

  const podiumStyles = () => {
    if (position == 1) {
      return ({
        width: '104px'
      });
    } else if (position === 2) {
      return ({
        width: '88px'
      });
    } else if (position === 3) {
      return ({
        width: '72px'
      });
    } else {
      const newPosition = 72 - position;
      return ({ width: `${ newPosition }px` });
    }
  };

  return (
    <TableCell onClick={ onClick }>
      <div className="competitors-table__cell-main">
        <div className="competitors-table__cell-sub">
          {
            showShirt && !hideDetail && (
              <img
                className={
                  classNames({
                    'competitors-table__shirt': true,
                    'competitors-table__shirt--hide': competitor.statusNumber > 1
                  })
                }
                src={ shirt }
              />
            )
          }
          <div className={
            classNames({
              'competitors-table--no-detail': hideDetail,
              'competitors-table--shirt': showShirt,
              'competitors-table--quick-charts': ellipsed
            })
          }
          >
            <span
              className={
                classNames({
                  'competitors-table__horse-name': true,
                  'competitors-table__horse-name--quick-charts': ellipsed,
                  'competitors-table__horse-name--scratched': competitor.statusNumber > 1
                })
              }
              title={ horseName ? horseName : '' }
            >
              { horseName ? horseName : '' }
            </span>
            {
              hideDetail && (
                <span className={ mobile ? 'competitors-table__expand-quick' : 'competitors-table__expand' }>{ expanded ? '-' : '+' }</span>
              )
            }
          </div>
          {
            showInfo && !hideDetail && (
              <>
                {
                  horseResults !== undefined &&
                    <div className={
                      classNames({ 'competitors-table__horse-performance':true,
                        'competitors-table__horse-performance--scratched': competitor?.statusNumber > 1,
                        'competitors-table--shirt': showShirt
                      })
                    }
                    >
                      { horseResults?.length > 0 && `(${ horseResults })` }
                    </div>
                }
                {
                  mobile ? (
                    <>
                      <div className={
                        classNames({
                          'competitors-table__horse-details': true,
                          'competitors-table__horse-details--scratched': competitor?.statusNumber > 1
                        })
                      }
                      >
                        {
                          <>
                            {
                              competitor?.horse?.age && competitor?.horse?.age !== 0 ?
                                `${ t('racingDetail.age', { age: competitor?.horse?.age }) }`
                                :
                                ''
                            }
                            { competitor?.horse?.gender && competitor?.horse?.gender || '' }
                          </>
                        }
                        <>&nbsp;</>
                        { !_.isNull(competitor?.weight) && t('racingDetail.weight', { weight: (+competitor.weight).toFixed(1) || 0.0 }) }
                      </div>
                      <div className="competitors-table__horse-details">
                        <div className="competitors-table__horse-details--trainer">
                          {
                            competitor?.jockey &&
                              <div>
                                <strong>J: </strong>
                                { competitor?.jockey.name ? !_.isUndefined(formatName) && formatName(competitor?.jockey.name) : '--' }
                              </div>
                          }
                        </div>
                        <div className="competitors-table__horse-details--trainer">
                          {
                            competitor?.trainer &&
                            <div>
                              <strong>T: </strong>
                              { !_.isUndefined(formatName) && formatName(competitor?.trainer.name) }
                            </div>
                          }
                          <span>{ expanded ? '-' : '+' }</span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="competitors-table__expand">{ checkCompetitor && !official ? (expanded ? '—' : '+') : '' }</div>
                  )
                }
              </>
            )
          }
        </div>
        {
          position <= podiumNr && !mobile &&
            <div className="competitors-table__podium-graphic">
              <div className="competitors-table__podium-graphic-box" style={ podiumStyles() } />
              <Icon className="competitors-table__racing-icon" icon={ racingType } />
            </div>
        }
      </div>
    </TableCell>
  );
}
